<script setup>
defineProps({
  bio: { type: String, default: null },
});
</script>

<template>
  <p
    v-if="bio"
    class="text-sm text-foreground/90 leading-relaxed line-clamp-4 whitespace-pre-line"
  >
    {{ bio }}
  </p>
</template>
